<template>
  <div class="coach-detail-info-page">
    <div class="header">
      <img class="img-person" v-if="info.extra_info.avatar != null" :src="info.extra_info.avatar" />
      <div class="button-box">
        <div 
          :class="[
            'leapin-ob-small',
            'leapin-light-huge-button',
            markType == 0 ? 'marked' : ''
          ]"
          @click.stop="saveCoach(info.extra_info.mark_type)">
          <img :src="star" /> SAVE
        </div>
        <div class="leapin-primary-huge-button leapin-ob-small" @click.stop="hireCoach(info.extra_info.id)">
          <img :src="linkAirWhite" /> HIRE
        </div>
      </div>
    </div>
    <!-- 人员信息 -->
    <div class="person-info-content">
      <!-- 基础信息 -->
      <div class="person-base-info">
        <div class="pic-title"> 
          <span class="name">{{ info.first_name }} {{ info.last_name }}</span>
        </div>
        <div class="pic-info">
          <div class="info-item">
            <img :src="linkAir" /> <span>{{ getEmptyBack(info.extra_info.work_year) }}</span> Yrs Of Experience
          </div>
          <div class="info-item">
            <img :src="linkAir" /> <span>{{ getEmptyBack(info.extra_info.coach_experience) }}</span> Hrs Coached
          </div>
        </div>
        <div class="pic-tips">
          {{ info.target_audience }}
        </div>
      </div>
      <!-- 关于我 -->
       <div class="about-me">
        <div class="item-title">
          <img :src="linkAir" /> CERTIFICATES
        </div>
        <!-- 证书 -->
        <Certificates :certList="info.extra_info.credentials"></Certificates>
        <div class="item-title">
          <img :src="linkAir" />  ABOUT ME
        </div>
        <div class="content">
          {{ getEmptyBack(info.extra_info.description) }}
        </div>
       </div>
       <!-- 关于coach的标签 -->
      <div class="coach-tags">
        <!-- 教练类型 -->
        <div class="item-title">
          <img :src="linkAir" />  COACHING TYPES
        </div>
        <div class="tags">
          <div class="leapin-tags leapin-blue" v-for="(item, index) in info.extra_info.coach_type" :key="index">
            {{ coachCode.find(target => target.value == item).name }}
          </div>
        </div>
        <!-- 目标受众 -->
        <div class="item-title">
          <img :src="linkAir" />  TARGET AUDIENCE
        </div>
        <div class="tags">
          <div class="leapin-tags leapin-blue" v-for="(item, index) in info.extra_info.target_audience" :key="index">
            {{ targetAudienceCode.find(target => target.value == item).name }}
          </div>
        </div>
        <!-- 专长 -->
        <div class="item-title">
          <img :src="linkAir" />  SPECIALTIES
        </div>
        <div class="tags">
          <div class="leapin-tags leapin-blue" v-for="(e,i) in info.extra_info.specialities" :key="i">
            {{ e }}
          </div>
        </div>
        <!-- 语言 -->
        <div class="item-title">
          <img :src="linkAir" />  LANGUAGES
        </div>
        <div class="tags">
          <div class="leapin-tags leapin-purple" v-for="(e,i) in info.extra_info.languages" :key="i">
            {{ languagesCode.find(item => item.value === e).name }}
          </div>
        </div>
      </div>
      <!-- 学历相关展示 -->
      <div class="education-box">
        <el-row :gutter="30">
          <el-col :span="12">
            <div class="eb-item">
              <div class="item-title">
                <img :src="linkAir" />  WORK EXPERIENCE
              </div>
              <!-- <div class="title-1">President & Founder</div>
              <div class="title-2">INSOL Consulting, LLC</div>
              <div class="title-2">2003-Present</div> -->
              <div class="content">
                {{ getEmptyBack(info.extra_info.work_experience) }}
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="eb-item">
              <div class="item-title">
                <img :src="linkAir" />  EDUCATION
              </div>
              <!-- <div class="title-1">President & Founder</div>
              <div class="title-2">INSOL Consulting, LLC</div>
              <div class="title-2">2003-Present</div> -->
              <div class="content">
                {{ getEmptyBack(info.extra_info.education) }}
              </div>
            </div>
          </el-col>
          <!-- <el-col class="eb-item" :span="7">
            <div class="item-title">
              <img :src="linkAir" />  CREDENTIALS
            </div>
            <div class="title-1">President & Founder</div>
            <div class="title-2">INSOL Consulting, LLC</div>
            <div class="title-2">2003-Present</div>
            <div class="link-adress">
              https://www.credly.com/badges/b78853a2-9438-44ea-a2df9dfe31f19db2/public ur
            </div>
          </el-col> -->
        </el-row>
      </div>

    </div>



  </div>
</template>

<script>
import { markCoach } from '@/services/coach'
import { COACH_CODE }  from '@/constants/coachCode'
import { TARGET_AUDIENCE_CODE } from '@/constants/targetAudience'
import { LANGUAGE_CODE } from '@/constants/languages'
export default {
  components: {
    Certificates: () => import('@/views/coach/components/certificates.vue')
  },
  props: {
    info: {
      type: Object,
      default: {
        extra_info: {}
      }
    }
  },
  data() {
    return {
      markType: 1,
      languagesCode: LANGUAGE_CODE,
      coachCode: COACH_CODE,
      targetAudienceCode: TARGET_AUDIENCE_CODE,
      coachTypeList: [
        'Corporate /organizational',
        'Executive (Leadership Development)',
        'Groups and Teams',
        'Personal Growth'
      ],
      targetAudienceList: [
        'CEO',
        'C-Suite',
        'Senior Leaders',
        'Middle Managers',
        'Individual Contributors'
      ],
      specialtiesList: [
        'Leadership Development',
        'Executive Coaching',
        'Team Coaching',
        'Personal Growth',
        'Career Transition',
        'Emotional Intelligence',
        'Communication Skills',
        'Conflict Resolution',
        'Stress Management',
        'Work-Life Balance',
        'Mindfulness',
        'Creativity and Innovation',
        'Diversity and Inclusion',
      ],
      languagesList: [
        'English',
        'Finnish',
        'Swedish',
        'German',
        'French',
        'Spanish',
      ],
      linkAir: require('@/assets/svgs/link-air.svg'),
      locationSvg: require('@/assets/svgs/location.svg'),
      linkAirWhite: require('@/assets/svgs/link-air-white.svg'),
      star: require('@/assets/svgs/star.svg'),
      coachDetailBg1: require('@/assets/images/coach/coach-detail-bg1.png'),
      peopleImg: require('@/assets/images/users/candidate3.png'),
    }
  },
  mounted () {
    this.markType = this.info.extra_info.mark_type
  },
  methods: {
    hireCoach (id) {
      this.$emit('hireCoachDetail',id)
    },
    // 标记coach
    saveCoach (type) {
      let parmas = {
        coach_id: this.info.id,
        mark_type: type == 0 ? 1 : 0 // 1, # 标记类型 0: 喜欢 1: 不喜欢
      }
      this.markType = parmas.mark_type
      markCoach(parmas).then(res => {
        if (res.code === 0) {
          this.$message.success('Operation succeed')
          this.$emit('saveCoachDetail')
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }
}
</script>
<style scoped lang="scss">
.coach-detail-info-page {
  background: #fff;
  border-radius: 30px 30px 0 0;
  .header {
    border-radius: 30px;
    height: 175px;
    width: 100%;
    background: url('../../assets/images/coach/coach-detail-bg1.png') no-repeat;
    background-position: top center;
    background-size: contain;
    position: relative;
    .img-person {
      position: absolute;
      width: 120px;
      height: 120px;
      object-fit: cover;
      bottom: 10px;
      left: 34px;
      border-radius: 50%;
    }
    .marked {
      background: #e9e8fa !important
    } 
    .button-box {
      position: absolute;
      bottom: 0;
      right: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0 10px;
    }
  }
  .person-info-content {
    padding: 0 32px 70px 32px;
    font-family: "PingFang SC";
    .person-base-info {
      padding-bottom: 24px;
      border-bottom: 1px solid #E5E5E5;
      .pic-title {
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          color: #000;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
        }
      }
      .pic-info {
        color: #000;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .info-item {
          width: fit-content;
          margin-right: 32px;
        }
        span {
          color: #6E62E5;
        }
      }
      .pic-tips {
        color: rgba(0, 0, 0, 0.5);
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
      }
    }
    .item-title {
      color: #000;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      letter-spacing: 0.5px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }
    .about-me {
      padding-top: 24px;
      font-size: 13px;
      border-bottom: 1px solid #E5E5E5;
      .content {
        color: #000;
        margin-bottom: 24px;
        letter-spacing: 1px;
        line-height: 15px;
      }
    }
    .coach-tags {
      padding-top: 24px;
      border-bottom: 1px solid #E5E5E5;
      .tags {
        display: flex;
        gap: 10px;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 24px;
        flex-wrap: wrap;
      }
    }
    .education-box {
      margin-top: 24px;
      background: #fff;
      .eb-item {
        border-radius: 12px;
        background: #F8F9FB;
        min-height: 200px;
        padding: 20px 18px;
        .title-1 {
          color: #000;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 500;
          padding: 0 28px;
          margin-bottom: 6px;
        }
        .title-2 {
          margin: 8px 0;
          color: #000;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          padding: 0 28px;
        }
        .content {
          padding: 0 28px;
          color: #000;
          font-size: 12px;
          font-weight: 400;
          line-height: 14px;
        }
        .link-adress {
          padding: 0 28px;
          color: #6E62E5;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          text-decoration-line: underline;
          word-wrap: break-word;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }

  }
}
</style>
